import { render, staticRenderFns } from "./BrowseActions.vue?vue&type=template&id=6454dd3e&scoped=true"
import script from "./BrowseActions.vue?vue&type=script&lang=ts"
export * from "./BrowseActions.vue?vue&type=script&lang=ts"
import style0 from "./BrowseActions.vue?vue&type=style&index=0&id=6454dd3e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454dd3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6454dd3e')) {
      api.createRecord('6454dd3e', component.options)
    } else {
      api.reload('6454dd3e', component.options)
    }
    module.hot.accept("./BrowseActions.vue?vue&type=template&id=6454dd3e&scoped=true", function () {
      api.rerender('6454dd3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseActions.vue"
export default component.exports